import Connection from "@/functions/Connection.js";

/**
 * Endpoint de status diario da fila de confirmacao de protocolo, exposto
 * pelo gspro12-api (issue #456) para a tela de conferencia diaria (#312).
 *
 * Rota montada no grupo autenticado do `start/routes.js` do backend:
 *   GET api/nota/status-diario?data=YYYY-MM-DD -> NotaController.statusDiario
 */
const RESOURCE = "nota/status-diario";

const NotaStatusDiarioService = {
  /**
   * Busca o resumo + lista de notas do dia informado.
   * @param {string} data 'YYYY-MM-DD'
   * @returns {Promise<{data:string, resumo:object, notas:Array}>}
   */
  async buscar (data) {
    return await Connection.get(RESOURCE, { params: { data } });
  }
};

export default NotaStatusDiarioService;
